import request from '@/utils/request';

export const login = (data: any) => request({
  url: '/auth/login',
  method: 'post',
  data,
});

export const getStaffInfo = () => request({
  url: '/auth/staff',
  method: 'get',
});
